import { useQueryParams, StringParam, SetQuery } from "use-query-params";

export type SocialAccountConnectQueryParams = Partial<
  Record<
    | "error"
    | "addLinkedin"
    | "connected"
    | "reconnected"
    | "reconnectedFromNotifications"
    | "accountId"
    | "addGmb"
    | "sub"
    | "addYt"
    | "successfullyUpdatedLi"
    | "successfullyUpdatedGmb"
    | "successfullyUpdatedYt"
    | "tour",
    string | null | undefined
  >
>;

const queryParamConfig = {
  error: StringParam,
  connected: StringParam,
  reconnected: StringParam,
  reconnectedFromNotifications: StringParam,
  accountId: StringParam,
  addLinkedin: StringParam,
  addGmb: StringParam,
  sub: StringParam,
  addYt: StringParam,
  successfullyUpdatedLi: StringParam,
  successfullyUpdatedGmb: StringParam,
  successfullyUpdatedYt: StringParam,
  tour: StringParam,
} as const;

export function useSocialAccountConnectQueryParams(): [
  SocialAccountConnectQueryParams,
  SetQuery<typeof queryParamConfig>,
] {
  return useQueryParams(queryParamConfig);
}
